import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

const URI_PREFIX = checkIsStoryBookPath('videos');
const TRENDS_PREFIX = 'trends';

export const apiRoutes = (isTrends = false): any => {
  const moduleName = window.location.pathname?.split('/')?.[1];
  const isTrendModule = moduleName === 'trends' || isTrends;
  const GENERATE_URI = isTrendModule
    ? `${TRENDS_PREFIX}/${URI_PREFIX}`
    : URI_PREFIX;
  return {
    //DASHBOARD
    totalVideosCount: `${URI_PREFIX}/dashboard/total-videos-count`,
    totalEntitiesCount: `${URI_PREFIX}/dashboard/total-channels-count`,
    videoPlatform: `${URI_PREFIX}/dashboard/videos-count-per-platform`,
    mostViewedVideos: `${URI_PREFIX}/dashboard/most-viewed-videos`,
    mostRecentVideos: `${URI_PREFIX}/dashboard/most-recently-videos`,
    trendingMap: `${GENERATE_URI}/trending/map/by-coordinates`,
    trendingVideos: `${GENERATE_URI}/trending`,
    topUsedHashtags: `${URI_PREFIX}/dashboard/top-used-hashtags`,
    lastFiveTrendingVideos: `${GENERATE_URI}/bar-latest-five-hour`,
    dashboardTrendingVideos: `${URI_PREFIX}/trending`,
    videosDashboardTrendingVideos: `${GENERATE_URI}/dashboard/secondary/trending`,
    videosDashboardTrendVideos: `${GENERATE_URI}/secondary/trending`,
    dashboardVideosMap: `${URI_PREFIX}/trending/map/by-coordinates`,
    videoGrabbingStatus: `${URI_PREFIX}/grabbing-status`,
    //table tabs
    tableAllTab: `${URI_PREFIX}/`,
    tableVideosTab: `${URI_PREFIX}/added`,
    tableTrendingTab: `${GENERATE_URI}/trending`,
    tableTrashedTab: `${GENERATE_URI}/trashed`,
    tableUnnecessaryTab: `${GENERATE_URI}/all-unnecessary`,
    tableIncompleteTab: `${GENERATE_URI}/incomplete`,
    addClientVideos: `${URI_PREFIX}/add-to-client-videos`,

    // All tab autocomplete
    allTabVideosAutoComplete: `${URI_PREFIX}`,
    allTabHashtagAutoComplete: `${URI_PREFIX}/hashtags`,
    // videos tab autocomplete
    videosTabVideosAutoComplete: `${URI_PREFIX}/added`,
    videosTabHashtagAutoComplete: `${URI_PREFIX}/hashtags/active`,

    // trending tab autocomplete
    trendingTabVideosAutoComplete: `${GENERATE_URI}/trending`,
    trendingTabHashtagsAutoComplete: `${GENERATE_URI}/hashtags/trending`,
    // trashed tab autocomplete
    trashedTabVideosAutoComplete: `${URI_PREFIX}/trashed`,
    trashedTabHashtagsAutoComplete: `${URI_PREFIX}/hashtags/trashed`,
    // unnecessary tab autocomplete
    unnecessaryTabAutocomplete: `${URI_PREFIX}/unnecessary`,
    unnecessaryTabHashtagsAutoComplete: `${URI_PREFIX}/hashtags/unnecessary`,
    // incomplete tab autocomplete
    incompleteTabAutocomplete: `${URI_PREFIX}/incomplete`,

    //inline actions
    trashVideo: `${GENERATE_URI}/trash`,
    deleteVideo: `${GENERATE_URI}/delete`,
    restoreVideo: `${GENERATE_URI}/restore`,
    unnecessaryVideo: `${GENERATE_URI}/unnecessary`,
    hideVideo: `${GENERATE_URI}/trash-or-unnecessary`,

    //videos view
    resyncVideo: `${GENERATE_URI}/resync`,
    showVideo: `${GENERATE_URI}/show`,
    videosGainedSubs: `${GENERATE_URI}/gained-subscriber-chart`,
    videosTrust: `${GENERATE_URI}/trust-chart`,
    videosEngagement: `${GENERATE_URI}/engagement-chart`,
    videosViewChart: `${GENERATE_URI}/view-chart`,
    videosSubscribeChart: `${GENERATE_URI}/subscriber-chart`,
    videoDetailsComments: `${GENERATE_URI}/comments`,
    videoRelatedTags: `${GENERATE_URI}/video/tags`,
    videosLastGrabbedOn: `${GENERATE_URI}/trending/last-grabbed-on`,

    //channel details
    channelSubscribers: `${GENERATE_URI}/channel/chart/gained-subscribers`,
    channelViews: `${GENERATE_URI}/channel/chart/views`,
    channelActivities: `${GENERATE_URI}/channel/chart/activities`,
    uploadedVideos: `${GENERATE_URI}/channel/chart/uploaded-videos`,

    // add video
    addVideo: `${URI_PREFIX}/store`,
    trendingList: `${GENERATE_URI}/trending/list-chart`,

    //Compare Video
    videoAutoComplete: `${GENERATE_URI}`,
    compareVideo: `${GENERATE_URI}/compare`,
    resyncTrendingVideos: `${GENERATE_URI}/trending/regrab`,
    logs: `${GENERATE_URI}`,

    userAutoComplete: `${GENERATE_URI}/activated`,
  };
};
